import React from 'react'
import MediaViewer, { MediaData } from 'components/MediaViewer'
import { useStyles } from './TagCell'
import { Dialog } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'

export interface MediaCellProps extends GridRenderCellParams {
    style?: { [key: string]: string }
    onClick?: () => void
}
interface ImageCellProps {
    value: MediaData
    width: number
    style?: { [key: string]: string }
    onClick?: () => void
}
const Container = styled.div`
    display: flex;
    justify-content: center;
    margin: 10px 0;
`

const GridCellExpand = React.memo(function GridCellExpand(props: ImageCellProps) {
    const { value, style, onClick } = props
    const [open, setOpen] = React.useState(false)
    const classes = useStyles()

    const handleClickCell = () => {
        if (!open) {
            setOpen(true)
            if (onClick) {
                onClick()
            }
        }
    }

    return (
        <Container className={classes.root} onClick={handleClickCell}>
            <MediaViewer
                mediaData={value as MediaData}
                showPopup={false}
                showArrowButtons={false}
                width="100%"
                maxHeight={style?.maxHeight || '40px'}
                style={
                    style
                        ? style
                        : {
                              maxWidth: '64px',
                              maxHeight: '40px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              margin: '0 auto',
                              objectPosition: '100% 0',
                          }
                }
            />
            <Dialog open={open} onClose={() => setOpen(false)}>
                <MediaViewer mediaData={value as MediaData} showPopup={false} maxHeight="500px" />
            </Dialog>
        </Container>
    )
})

export const MediaCell = (params: MediaCellProps) => {
    return params.value ? (
        <GridCellExpand value={params.value as MediaData} width={500} style={params?.style} onClick={params?.onClick} />
    ) : (
        <></>
    )
}
